<mat-list-item>
  <mat-icon matListItemIcon>bookmark</mat-icon>
  <span matListItemTitle>Patient Pinned Notes</span>
  <pr-content-view
    *ngFor="let note of notes$ | ngrxPush; trackBy: trackByNote"
    matListItemLine
    [content]="note.content"
   />
</mat-list-item>
